var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 11,
    viewBox: "0 0 13 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.8565 3.28003C11.3486 2.93066 11.7625 2.49457 12.0998 1.99244V1.99194C11.6496 2.18906 11.1706 2.32014 10.6705 2.38366C11.1847 2.07664 11.5775 1.59417 11.762 1.01289C11.2825 1.29874 10.7532 1.5004 10.189 1.61333C9.7338 1.12834 9.08496 0.828369 8.37714 0.828369C7.00385 0.828369 5.89825 1.94304 5.89825 3.30927C5.89825 3.50589 5.91489 3.69495 5.95573 3.87493C3.89377 3.7741 2.06876 2.78597 0.842673 1.28008C0.628915 1.65164 0.502878 2.07664 0.502878 2.5339C0.502878 3.39296 0.945015 4.15422 1.60494 4.59535C1.20616 4.58779 0.815449 4.47184 0.484225 4.28984V4.31706C0.484225 5.52248 1.34379 6.52371 2.47157 6.75461C2.26941 6.81007 2.0496 6.83628 1.82122 6.83628C1.66241 6.83628 1.5021 6.82721 1.35186 6.79393C1.673 7.77601 2.58551 8.49845 3.66942 8.52215C2.82548 9.18208 1.75367 9.57985 0.593624 9.57985C0.390453 9.57985 0.195349 9.57077 0.000244141 9.54607C1.09928 10.2544 2.40099 10.6592 3.80554 10.6592C8.18304 10.6592 11.036 7.00719 10.8565 3.28003Z",
    fill: "#9597AE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.c80e082393db2049cd8134b90dd7f171.svg";
export { ForwardRef as ReactComponent };